export default __webpack_public_path__ + "static/media/PartyLetPlain.245b3238.ttf";